import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex"
	},

	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		})
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},

	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap"
	},

	drawerOpen: {
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		background: `linear-gradient(180deg, ${colors.beige[50]} 0%, ${colors.purple[50]} 46.63%)`,
		borderRight: `1px solid ${colors.gray[200]}`,
		boxSizing: "border-box"
	},

	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		overflowX: "hidden",
		width: "84px",
		background: `linear-gradient(180deg, ${colors.beige[50]} 0%, ${colors.purple[50]} 46.63%)`,
		borderRight: `1px solid ${colors.gray[200]}`,
		boxSizing: "border-box"
	},

	content: {
		flexGrow: 1
	},

	drawerInternalContainer: {
		display: "flex",
		flexDirection: "column",
		height: "100%",
		flexWrap: "nowrap",
		minHeight: 0
	},

	logoRow: {
		padding: "20px 16px 10px 20px"
	},

	logoContainerDrawer: {
		display: "flex",
		flexShrink: 0,
		justifyContent: "center"
	},

	logoContainerDrawerClosed: {
		display: "flex",
		flexShrink: 0,
		justifyContent: "center",
		width: "100%"
	},

	listContainer: {
		overflowY: "auto",
		overflowX: "hidden",
		minHeight: 0,
		display: "flex",
		flexDirection: "column",
		paddingBottom: 0,
		paddingTop: 10
	},

	listContainerMobile: {
		flexGrow: 1,
		flexShrink: 1,
		flexBasis: 0,
		overflowY: "auto",
		overflowX: "hidden",
		minHeight: 0,
		display: "flex",
		flexDirection: "column",
		paddingBottom: 0
	},

	list: {
		paddingTop: 0,
		paddingBottom: 0,
		alignItems: "center"
	},

	logo: {
		maxWidth: "68px",
		height: "auto"
	},

	verticalLogo: {
		maxWidth: "28px",
		height: "auto"
	},

	icon: {
		color: colors.gray[700]
	},

	helpIcon: {
		color: colors.gray[500],
		strokeWidth: "1.3px"
	},

	minimizeIcon: {
		cursor: "pointer",
		color: colors.gray[500],
		width: "20px",
		height: "20px",
		"&:hover": { color: colors.gray[400] }
	},

	minimizeIconContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},

	maximizeIconWrapper: {
		display: "flex",
		justifyContent: "center",
		paddingTop: "10px",
		paddingBottom: "24px"
	},

	bottomContainer: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		gap: "24px",
		paddingBottom: "40px"
	},

	sidebarDivider: {
		marginLeft: "16px",
		marginRight: "16px"
	},

	bottomFixed: {
		flexShrink: 0,
		flexGrow: 0,
		flexBasis: "auto",
		zIndex: 100,
		width: "100%",
		paddingTop: 0
	},

	bottomFixedBackground: {
		flexShrink: 0,
		flexGrow: 0,
		flexBasis: "auto",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		zIndex: 100,
		width: "100%",
		paddingTop: 0
	},

	goToInboxButtonContainer: {
		padding: "12px 16px 12px 16px",
		width: "100%",
		boxSizing: "border-box"
	},

	goToInboxButtonContainerClosed: {
		padding: "12px 0",
		display: "flex",
		justifyContent: "center"
	},

	goToInboxButton: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		padding: "10px 16px",
		backgroundColor: "transparent",
		color: colors.purple[500],
		border: `1px solid ${colors.purple[500]}`,
		borderRadius: "8px",
		cursor: "pointer",
		fontSize: "14px",
		fontWeight: 700,
		minWidth: "unset",
		"&:hover": {
			backgroundColor: colors.purple[100]
		}
	},

	goToInboxButtonClosed: {
		backgroundColor: "transparent",
		color: colors.purple[500],
		border: `1px solid ${colors.purple[500]}`,
		padding: "8px",
		width: "auto",
		minWidth: "unset",
		borderRadius: "8px",
		"&:hover": {
			backgroundColor: colors.purple[100]
		}
	}
}))

export default useStyles
